// extracted by mini-css-extract-plugin
export var container = "_lp-0";
export var segment = "_lp-2";
export var segmentActive = "_lp-3";
export var track = "_lp-1";